module.exports = __webpack_public_path__ + "static/media/Portraits-3.8329200e.jpg";